import * as Yup from 'yup'
import { transformStringDateFormatToDate } from '@/shared'

export const ValidationSchema = () =>
	Yup.object().shape({
		orderNumber: Yup.string().required({ key: 'required' }).nullable(),
		orderDate: transformStringDateFormatToDate().required({ key: 'required' }).nullable(),
	})
